import styled from 'styled-components';

export const GrayShadowBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    box-shadow: 0px 0.2778vw 2.0833vw 0px rgba(0, 0, 0, 0.12);
`;